export default function SEO() {
  const stats = [
    {
      number: '250%',
      label: 'Average Traffic Increase',
      description: 'Within first 6 months'
    },
    {
      number: '3x',
      label: 'More Client Inquiries',
      description: 'From organic search'
    },
    {
      number: '#1',
      label: 'Local Search Rankings',
      description: 'For target keywords'
    }
  ];

  const seoFeatures = [
    {
      icon: 'ri-map-pin-line',
      title: 'Local SEO Mastery',
      description: 'Dominate search results in your service area and get found by local attorneys and legal firms.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Content Strategy',
      description: 'Engaging, keyword-optimized content that positions you as an industry expert and attracts ideal clients.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Performance Tracking',
      description: 'Detailed monthly reports showing your rankings, traffic growth, and ROI from our SEO efforts.'
    },
    {
      icon: 'ri-links-line',
      title: 'Authority Building',
      description: 'Strategic link building and citations to establish your credibility in the court reporting industry.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-[#1A2332] text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-line-chart-line mr-2"></i>
            Results That Matter
          </div>
          <h2 className="font-['Playfair_Display'] text-5xl font-bold text-[#1A2332] mb-4">
            Dominate Local Search Results
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our specialized SEO strategies help court reporters get found by attorneys and legal professionals actively searching for your services
          </p>
        </div>

        {/* Statistics */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-8 text-center hover:shadow-xl transition-shadow"
            >
              <div className="font-['Playfair_Display'] text-6xl font-bold text-[#FF6B6B] mb-3">
                {stat.number}
              </div>
              <div className="text-xl font-semibold text-[#1A2332] mb-2">
                {stat.label}
              </div>
              <div className="text-sm text-gray-600">
                {stat.description}
              </div>
            </div>
          ))}
        </div>

        {/* SEO Features Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {seoFeatures.map((feature, index) => (
            <div
              key={index}
              className="flex gap-6 p-6 bg-[#F8F9FA] rounded-xl hover:bg-[#FF6B6B]/5 transition-colors"
            >
              <div className="flex-shrink-0">
                <div className="w-14 h-14 bg-[#FF6B6B] rounded-xl flex items-center justify-center">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div>
                <h3 className="font-['Playfair_Display'] text-xl font-bold text-[#1A2332] mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="#contact"
            className="inline-flex items-center bg-[#FF6B6B] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#ff5252] transition-colors whitespace-nowrap cursor-pointer shadow-lg"
          >
            See Our SEO Strategy
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <p className="text-sm text-gray-600 mt-4">No long-term contracts required</p>
        </div>

        {/* Testimonial */}
        <div className="mt-20 bg-gradient-to-r from-[#1A2332] to-[#2a3342] rounded-2xl p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <i className="ri-double-quotes-l text-5xl text-[#FF6B6B] mb-6 block"></i>
            <p className="text-xl text-white mb-6 leading-relaxed">
              "Within 3 months of working with Court Reporters Websites, we went from page 3 to the #1 spot for 'court reporters in Chicago.' Our phone hasn't stopped ringing with quality leads from attorneys who found us on Google."
            </p>
            <div className="flex items-center justify-center gap-4">
              <img
                src="https://public.readdy.ai/ai/img_res/f80287ba01018f8d1190dc054b297ea7.jpg"
                alt="Client"
                className="w-16 h-16 rounded-full object-cover object-top"
              />
              <div className="text-left">
                <div className="font-semibold text-white">Michael Rodriguez</div>
                <div className="text-gray-300 text-sm">Chicago Court Reporting Services</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
